import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from '@ipg/ngx-frontend-toolset';
import { ClientEditor } from '../../../models/clients.model';

@Injectable({
  providedIn: 'root',
})
export class ClientEditorService {
  private readonly _backend = inject(BackendService);

  getEditors(clientId: string): Observable<ClientEditor[]> {
    return this._backend.get(`/clients/${clientId}/editors`);
  }

  claimRange(clientId: string, data: { fromDate: Date; toDate: Date }) {
    return this._backend.post(`/clients/${clientId}/editors`, data);
  }

  updateActivity(clientId: string) {
    return this._backend.put(`/clients/${clientId}/editors/activity`, null);
  }

  revoke(clientId: string) {
    return this._backend.delete(`/clients/${clientId}/editors`);
  }
}
